import { cn } from "@discovery/classnames";
import React from "react";
import { SonicImageDplus } from "../../../../atoms/sonic-image";
import { Link } from "../../../../atoms/link";
import { HeightVariant, PlaceholderImage, } from "../../../../atoms/placeholder-image";
import * as styles from "./styles.css";
import { useDecoratedRoute } from "../../../../../utils/hooks";
export const SquareLogoMobileCard = ({ mobileImg, route, decoratorTheme, }) => {
    const { decoratedRoute } = useDecoratedRoute(decoratorTheme, route);
    return (React.createElement(Link, { href: decoratedRoute },
        React.createElement("div", { className: styles.showCard },
            React.createElement("div", { className: cn(styles.categorycardContainer) },
                React.createElement("div", { className: styles.showWrapper },
                    React.createElement("div", null,
                        React.createElement(PlaceholderImage, { variant: HeightVariant.TaxonomyHero })),
                    mobileImg && (React.createElement(SonicImageDplus, { src: mobileImg.src, quality: 75, className: styles.topShowImages, width: 300 })))))));
};

